// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_configuration.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { LLMIntegrationPhase, SupportedModel } from "./agent_pb";
import { file_gitpod_v1_agent } from "./agent_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/runner_configuration.proto.
 */
export const file_gitpod_v1_runner_configuration: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_agent, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_gnostic_openapi_v3_annotations, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.CreateHostAuthenticationTokenRequest
 */
export type CreateHostAuthenticationTokenRequest = Message<"gitpod.v1.CreateHostAuthenticationTokenRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * Deprecated: Use principal_id and principal_type instead
   *
   * @generated from field: string user_id = 2 [deprecated = true];
   * @deprecated
   */
  userId: string;

  /**
   * @generated from field: string host = 3;
   */
  host: string;

  /**
   * stored encrypted, retrieved via GetHostAuthenticationTokenValue
   *
   * @generated from field: string token = 4;
   */
  token: string;

  /**
   * @generated from field: gitpod.v1.HostAuthenticationTokenSource source = 5;
   */
  source: HostAuthenticationTokenSource;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * stored encrypted, retrieved via GetHostAuthenticationTokenValue
   *
   * @generated from field: string refresh_token = 7;
   */
  refreshToken: string;

  /**
   * @generated from field: string integration_id = 8;
   */
  integrationId: string;

  /**
   * Maximum 100 scopes allowed (101 for validation purposes)
   *
   * @generated from field: repeated string scopes = 9;
   */
  scopes: string[];

  /**
   * Subject identifies the principal (user or service account) for the token
   *
   * @generated from field: gitpod.v1.Subject subject = 10;
   */
  subject?: Subject;
};

/**
 * Describes the message gitpod.v1.CreateHostAuthenticationTokenRequest.
 * Use `create(CreateHostAuthenticationTokenRequestSchema)` to create a new message.
 */
export const CreateHostAuthenticationTokenRequestSchema: GenMessage<CreateHostAuthenticationTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 0);

/**
 * @generated from message gitpod.v1.CreateHostAuthenticationTokenResponse
 */
export type CreateHostAuthenticationTokenResponse = Message<"gitpod.v1.CreateHostAuthenticationTokenResponse"> & {
  /**
   * @generated from field: gitpod.v1.HostAuthenticationToken token = 1;
   */
  token?: HostAuthenticationToken;
};

/**
 * Describes the message gitpod.v1.CreateHostAuthenticationTokenResponse.
 * Use `create(CreateHostAuthenticationTokenResponseSchema)` to create a new message.
 */
export const CreateHostAuthenticationTokenResponseSchema: GenMessage<CreateHostAuthenticationTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 1);

/**
 * @generated from message gitpod.v1.HostAuthenticationToken
 */
export type HostAuthenticationToken = Message<"gitpod.v1.HostAuthenticationToken"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * Deprecated: Use principal_id and principal_type instead
   *
   * principal (user)
   *
   * @generated from field: string user_id = 3 [deprecated = true];
   * @deprecated
   */
  userId: string;

  /**
   * @generated from field: string host = 4;
   */
  host: string;

  /**
   * auth_type
   *
   * @generated from field: gitpod.v1.HostAuthenticationTokenSource source = 5;
   */
  source: HostAuthenticationTokenSource;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * links to integration instance
   *
   * @generated from field: string integration_id = 7;
   */
  integrationId: string;

  /**
   * token permissions
   *
   * @generated from field: repeated string scopes = 8;
   */
  scopes: string[];

  /**
   * Subject identifies the principal (user or service account) for the token
   *
   * Note: actual token and refresh_token values are retrieved via GetHostAuthenticationTokenValue API
   *
   * @generated from field: gitpod.v1.Subject subject = 9;
   */
  subject?: Subject;
};

/**
 * Describes the message gitpod.v1.HostAuthenticationToken.
 * Use `create(HostAuthenticationTokenSchema)` to create a new message.
 */
export const HostAuthenticationTokenSchema: GenMessage<HostAuthenticationToken> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 2);

/**
 * @generated from message gitpod.v1.GetHostAuthenticationTokenRequest
 */
export type GetHostAuthenticationTokenRequest = Message<"gitpod.v1.GetHostAuthenticationTokenRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.GetHostAuthenticationTokenRequest.
 * Use `create(GetHostAuthenticationTokenRequestSchema)` to create a new message.
 */
export const GetHostAuthenticationTokenRequestSchema: GenMessage<GetHostAuthenticationTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 3);

/**
 * @generated from message gitpod.v1.GetHostAuthenticationTokenResponse
 */
export type GetHostAuthenticationTokenResponse = Message<"gitpod.v1.GetHostAuthenticationTokenResponse"> & {
  /**
   * @generated from field: gitpod.v1.HostAuthenticationToken token = 1;
   */
  token?: HostAuthenticationToken;
};

/**
 * Describes the message gitpod.v1.GetHostAuthenticationTokenResponse.
 * Use `create(GetHostAuthenticationTokenResponseSchema)` to create a new message.
 */
export const GetHostAuthenticationTokenResponseSchema: GenMessage<GetHostAuthenticationTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 4);

/**
 * @generated from message gitpod.v1.ListHostAuthenticationTokensRequest
 */
export type ListHostAuthenticationTokensRequest = Message<"gitpod.v1.ListHostAuthenticationTokensRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListHostAuthenticationTokensRequest.Filter filter = 2;
   */
  filter?: ListHostAuthenticationTokensRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListHostAuthenticationTokensRequest.
 * Use `create(ListHostAuthenticationTokensRequestSchema)` to create a new message.
 */
export const ListHostAuthenticationTokensRequestSchema: GenMessage<ListHostAuthenticationTokensRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 5);

/**
 * @generated from message gitpod.v1.ListHostAuthenticationTokensRequest.Filter
 */
export type ListHostAuthenticationTokensRequest_Filter = Message<"gitpod.v1.ListHostAuthenticationTokensRequest.Filter"> & {
  /**
   * @generated from field: optional string runner_id = 1;
   */
  runnerId?: string;

  /**
   * Deprecated: Use principal_id instead
   *
   * @generated from field: optional string user_id = 2 [deprecated = true];
   * @deprecated
   */
  userId?: string;

  /**
   * Filter by subject (user or service account)
   *
   * @generated from field: optional string subject_id = 3;
   */
  subjectId?: string;
};

/**
 * Describes the message gitpod.v1.ListHostAuthenticationTokensRequest.Filter.
 * Use `create(ListHostAuthenticationTokensRequest_FilterSchema)` to create a new message.
 */
export const ListHostAuthenticationTokensRequest_FilterSchema: GenMessage<ListHostAuthenticationTokensRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 5, 0);

/**
 * @generated from message gitpod.v1.ListHostAuthenticationTokensResponse
 */
export type ListHostAuthenticationTokensResponse = Message<"gitpod.v1.ListHostAuthenticationTokensResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.HostAuthenticationToken tokens = 2;
   */
  tokens: HostAuthenticationToken[];
};

/**
 * Describes the message gitpod.v1.ListHostAuthenticationTokensResponse.
 * Use `create(ListHostAuthenticationTokensResponseSchema)` to create a new message.
 */
export const ListHostAuthenticationTokensResponseSchema: GenMessage<ListHostAuthenticationTokensResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 6);

/**
 * @generated from message gitpod.v1.UpdateHostAuthenticationTokenRequest
 */
export type UpdateHostAuthenticationTokenRequest = Message<"gitpod.v1.UpdateHostAuthenticationTokenRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string token = 5;
   */
  token?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: optional string refresh_token = 7;
   */
  refreshToken?: string;

  /**
   * @generated from field: repeated string scopes = 8;
   */
  scopes: string[];
};

/**
 * Describes the message gitpod.v1.UpdateHostAuthenticationTokenRequest.
 * Use `create(UpdateHostAuthenticationTokenRequestSchema)` to create a new message.
 */
export const UpdateHostAuthenticationTokenRequestSchema: GenMessage<UpdateHostAuthenticationTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 7);

/**
 * @generated from message gitpod.v1.UpdateHostAuthenticationTokenResponse
 */
export type UpdateHostAuthenticationTokenResponse = Message<"gitpod.v1.UpdateHostAuthenticationTokenResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateHostAuthenticationTokenResponse.
 * Use `create(UpdateHostAuthenticationTokenResponseSchema)` to create a new message.
 */
export const UpdateHostAuthenticationTokenResponseSchema: GenMessage<UpdateHostAuthenticationTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 8);

/**
 * @generated from message gitpod.v1.UpdateHostAuthenticationTokenMetadataRequest
 */
export type UpdateHostAuthenticationTokenMetadataRequest = Message<"gitpod.v1.UpdateHostAuthenticationTokenMetadataRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: optional string external_user_id = 3;
   */
  externalUserId?: string;
};

/**
 * Describes the message gitpod.v1.UpdateHostAuthenticationTokenMetadataRequest.
 * Use `create(UpdateHostAuthenticationTokenMetadataRequestSchema)` to create a new message.
 */
export const UpdateHostAuthenticationTokenMetadataRequestSchema: GenMessage<UpdateHostAuthenticationTokenMetadataRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 9);

/**
 * @generated from message gitpod.v1.UpdateHostAuthenticationTokenMetadataResponse
 */
export type UpdateHostAuthenticationTokenMetadataResponse = Message<"gitpod.v1.UpdateHostAuthenticationTokenMetadataResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateHostAuthenticationTokenMetadataResponse.
 * Use `create(UpdateHostAuthenticationTokenMetadataResponseSchema)` to create a new message.
 */
export const UpdateHostAuthenticationTokenMetadataResponseSchema: GenMessage<UpdateHostAuthenticationTokenMetadataResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 10);

/**
 * @generated from message gitpod.v1.DeleteHostAuthenticationTokenRequest
 */
export type DeleteHostAuthenticationTokenRequest = Message<"gitpod.v1.DeleteHostAuthenticationTokenRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.DeleteHostAuthenticationTokenRequest.
 * Use `create(DeleteHostAuthenticationTokenRequestSchema)` to create a new message.
 */
export const DeleteHostAuthenticationTokenRequestSchema: GenMessage<DeleteHostAuthenticationTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 11);

/**
 * @generated from message gitpod.v1.DeleteHostAuthenticationTokenResponse
 */
export type DeleteHostAuthenticationTokenResponse = Message<"gitpod.v1.DeleteHostAuthenticationTokenResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteHostAuthenticationTokenResponse.
 * Use `create(DeleteHostAuthenticationTokenResponseSchema)` to create a new message.
 */
export const DeleteHostAuthenticationTokenResponseSchema: GenMessage<DeleteHostAuthenticationTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 12);

/**
 * @generated from message gitpod.v1.FieldValue
 */
export type FieldValue = Message<"gitpod.v1.FieldValue"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message gitpod.v1.FieldValue.
 * Use `create(FieldValueSchema)` to create a new message.
 */
export const FieldValueSchema: GenMessage<FieldValue> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 13);

/**
 * @generated from message gitpod.v1.FieldValueUpdate
 */
export type FieldValueUpdate = Message<"gitpod.v1.FieldValueUpdate"> & {
  /**
   * key is the field key to update. If the field does not exist, it will be created.
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * value is the new value for the field. If value is empty, the field will be removed.
   *
   * @generated from field: optional string value = 2;
   */
  value?: string;
};

/**
 * Describes the message gitpod.v1.FieldValueUpdate.
 * Use `create(FieldValueUpdateSchema)` to create a new message.
 */
export const FieldValueUpdateSchema: GenMessage<FieldValueUpdate> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 14);

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationSchemaRequest
 */
export type GetRunnerConfigurationSchemaRequest = Message<"gitpod.v1.GetRunnerConfigurationSchemaRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerConfigurationSchemaRequest.
 * Use `create(GetRunnerConfigurationSchemaRequestSchema)` to create a new message.
 */
export const GetRunnerConfigurationSchemaRequestSchema: GenMessage<GetRunnerConfigurationSchemaRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 15);

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationSchemaResponse
 */
export type GetRunnerConfigurationSchemaResponse = Message<"gitpod.v1.GetRunnerConfigurationSchemaResponse"> & {
  /**
   * @generated from field: gitpod.v1.RunnerConfigurationSchema schema = 1;
   */
  schema?: RunnerConfigurationSchema;
};

/**
 * Describes the message gitpod.v1.GetRunnerConfigurationSchemaResponse.
 * Use `create(GetRunnerConfigurationSchemaResponseSchema)` to create a new message.
 */
export const GetRunnerConfigurationSchemaResponseSchema: GenMessage<GetRunnerConfigurationSchemaResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 16);

/**
 * @generated from message gitpod.v1.CreateSCMIntegrationRequest
 */
export type CreateSCMIntegrationRequest = Message<"gitpod.v1.CreateSCMIntegrationRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * scm_id references the scm_id in the runner's configuration schema that this integration is for
   *
   * @generated from field: string scm_id = 2;
   */
  scmId: string;

  /**
   * @generated from field: string host = 3;
   */
  host: string;

  /**
   * oauth_client_id is the OAuth app's client ID, if OAuth is configured.
   * If configured, oauth_plaintext_client_secret must also be set.
   *
   * @generated from field: optional string oauth_client_id = 4;
   */
  oauthClientId?: string;

  /**
   * oauth_plaintext_client_secret is the OAuth app's client secret in clear text.
   * This will first be encrypted with the runner's public key before being stored.
   *
   * @generated from field: optional string oauth_plaintext_client_secret = 5;
   */
  oauthPlaintextClientSecret?: string;

  /**
   * @generated from field: bool pat = 6;
   */
  pat: boolean;

  /**
   * issuer_url can be set to override the authentication provider URL, if it doesn't match the SCM host.
   *
   * @generated from field: optional string issuer_url = 7;
   */
  issuerUrl?: string;

  /**
   * virtual_directory is the virtual directory path for Azure DevOps Server (e.g., "/tfs").
   * This field is only used for Azure DevOps Server SCM integrations and should be empty for other SCM types.
   * Azure DevOps Server APIs work without collection when PAT scope is 'All accessible organizations'.
   *
   * @generated from field: optional string virtual_directory = 8;
   */
  virtualDirectory?: string;
};

/**
 * Describes the message gitpod.v1.CreateSCMIntegrationRequest.
 * Use `create(CreateSCMIntegrationRequestSchema)` to create a new message.
 */
export const CreateSCMIntegrationRequestSchema: GenMessage<CreateSCMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 17);

/**
 * @generated from message gitpod.v1.CreateSCMIntegrationResponse
 */
export type CreateSCMIntegrationResponse = Message<"gitpod.v1.CreateSCMIntegrationResponse"> & {
  /**
   * id is a uniquely generated identifier for the SCM integration
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.CreateSCMIntegrationResponse.
 * Use `create(CreateSCMIntegrationResponseSchema)` to create a new message.
 */
export const CreateSCMIntegrationResponseSchema: GenMessage<CreateSCMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 18);

/**
 * @generated from message gitpod.v1.SCMIntegrationOAuthConfig
 */
export type SCMIntegrationOAuthConfig = Message<"gitpod.v1.SCMIntegrationOAuthConfig"> & {
  /**
   * client_id is the OAuth app's client ID in clear text.
   *
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * encrypted_client_secret is the OAuth app's secret encrypted with the runner's public key.
   *
   * @generated from field: bytes encrypted_client_secret = 2;
   */
  encryptedClientSecret: Uint8Array;

  /**
   * issuer_url is used to override the authentication provider URL, if it doesn't match the SCM host.
   *
   * +optional if not set, this account is owned by the installation.
   *
   * @generated from field: string issuer_url = 3;
   */
  issuerUrl: string;
};

/**
 * Describes the message gitpod.v1.SCMIntegrationOAuthConfig.
 * Use `create(SCMIntegrationOAuthConfigSchema)` to create a new message.
 */
export const SCMIntegrationOAuthConfigSchema: GenMessage<SCMIntegrationOAuthConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 19);

/**
 * @generated from message gitpod.v1.SCMIntegration
 */
export type SCMIntegration = Message<"gitpod.v1.SCMIntegration"> & {
  /**
   *  id is the unique identifier of the SCM integration
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * scm_id references the scm_id in the runner's configuration schema that this integration is for
   *
   * @generated from field: string scm_id = 2;
   */
  scmId: string;

  /**
   * @generated from field: string host = 3;
   */
  host: string;

  /**
   * @generated from field: optional gitpod.v1.SCMIntegrationOAuthConfig oauth = 4;
   */
  oauth?: SCMIntegrationOAuthConfig;

  /**
   * @generated from field: bool pat = 5;
   */
  pat: boolean;

  /**
   * @generated from field: string runner_id = 6;
   */
  runnerId: string;

  /**
   * virtual_directory is the virtual directory path for Azure DevOps Server (e.g., "/tfs").
   * This field is only used for Azure DevOps Server SCM integrations and should be empty for other SCM types.
   * Azure DevOps Server APIs work without collection when PAT scope is 'All accessible organizations'.
   *
   * @generated from field: optional string virtual_directory = 7;
   */
  virtualDirectory?: string;
};

/**
 * Describes the message gitpod.v1.SCMIntegration.
 * Use `create(SCMIntegrationSchema)` to create a new message.
 */
export const SCMIntegrationSchema: GenMessage<SCMIntegration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 20);

/**
 * @generated from message gitpod.v1.GetSCMIntegrationRequest
 */
export type GetSCMIntegrationRequest = Message<"gitpod.v1.GetSCMIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.GetSCMIntegrationRequest.
 * Use `create(GetSCMIntegrationRequestSchema)` to create a new message.
 */
export const GetSCMIntegrationRequestSchema: GenMessage<GetSCMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 21);

/**
 * @generated from message gitpod.v1.GetSCMIntegrationResponse
 */
export type GetSCMIntegrationResponse = Message<"gitpod.v1.GetSCMIntegrationResponse"> & {
  /**
   * @generated from field: gitpod.v1.SCMIntegration integration = 1;
   */
  integration?: SCMIntegration;
};

/**
 * Describes the message gitpod.v1.GetSCMIntegrationResponse.
 * Use `create(GetSCMIntegrationResponseSchema)` to create a new message.
 */
export const GetSCMIntegrationResponseSchema: GenMessage<GetSCMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 22);

/**
 * @generated from message gitpod.v1.ListSCMIntegrationsRequest
 */
export type ListSCMIntegrationsRequest = Message<"gitpod.v1.ListSCMIntegrationsRequest"> & {
  /**
   * pagination contains the pagination options for listing scm integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListSCMIntegrationsRequest.Filter filter = 2;
   */
  filter?: ListSCMIntegrationsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListSCMIntegrationsRequest.
 * Use `create(ListSCMIntegrationsRequestSchema)` to create a new message.
 */
export const ListSCMIntegrationsRequestSchema: GenMessage<ListSCMIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 23);

/**
 * @generated from message gitpod.v1.ListSCMIntegrationsRequest.Filter
 */
export type ListSCMIntegrationsRequest_Filter = Message<"gitpod.v1.ListSCMIntegrationsRequest.Filter"> & {
  /**
   * runner_ids filters the response to only SCM integrations of these Runner IDs
   *
   * @generated from field: repeated string runner_ids = 1;
   */
  runnerIds: string[];
};

/**
 * Describes the message gitpod.v1.ListSCMIntegrationsRequest.Filter.
 * Use `create(ListSCMIntegrationsRequest_FilterSchema)` to create a new message.
 */
export const ListSCMIntegrationsRequest_FilterSchema: GenMessage<ListSCMIntegrationsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 23, 0);

/**
 * @generated from message gitpod.v1.ListSCMIntegrationsResponse
 */
export type ListSCMIntegrationsResponse = Message<"gitpod.v1.ListSCMIntegrationsResponse"> & {
  /**
   * pagination contains the pagination options for listing scm integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.SCMIntegration integrations = 2;
   */
  integrations: SCMIntegration[];
};

/**
 * Describes the message gitpod.v1.ListSCMIntegrationsResponse.
 * Use `create(ListSCMIntegrationsResponseSchema)` to create a new message.
 */
export const ListSCMIntegrationsResponseSchema: GenMessage<ListSCMIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 24);

/**
 * @generated from message gitpod.v1.UpdateSCMIntegrationRequest
 */
export type UpdateSCMIntegrationRequest = Message<"gitpod.v1.UpdateSCMIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * oauth_client_id can be set to update the OAuth app's client ID.
   * If an empty string is set, the OAuth configuration will be removed (regardless
   * of whether a client secret is set), and any existing Host Authentication Tokens for the
   * SCM integration's runner and host that were created using the OAuth app will be deleted.
   * This might lead to users being unable to access their repositories until they re-authenticate.
   *
   * @generated from field: optional string oauth_client_id = 2;
   */
  oauthClientId?: string;

  /**
   * oauth_plaintext_client_secret can be set to update the OAuth app's client secret.
   * The cleartext secret will be encrypted with the runner's public key before being stored.
   *
   * @generated from field: optional string oauth_plaintext_client_secret = 3;
   */
  oauthPlaintextClientSecret?: string;

  /**
   * pat can be set to enable or disable Personal Access Tokens support.
   * When disabling PATs, any existing Host Authentication Tokens for the SCM integration's
   * runner and host that were created using a PAT will be deleted. This might lead to users
   * being unable to access their repositories until they re-authenticate.
   *
   * @generated from field: optional bool pat = 4;
   */
  pat?: boolean;

  /**
   * issuer_url can be set to override the authentication provider URL, if it doesn't match the SCM host.
   *
   * @generated from field: optional string issuer_url = 5;
   */
  issuerUrl?: string;

  /**
   * virtual_directory is the virtual directory path for Azure DevOps Server (e.g., "/tfs").
   * This field is only used for Azure DevOps Server SCM integrations and should be empty for other SCM types.
   * Azure DevOps Server APIs work without collection when PAT scope is 'All accessible organizations'.
   *
   * @generated from field: optional string virtual_directory = 6;
   */
  virtualDirectory?: string;
};

/**
 * Describes the message gitpod.v1.UpdateSCMIntegrationRequest.
 * Use `create(UpdateSCMIntegrationRequestSchema)` to create a new message.
 */
export const UpdateSCMIntegrationRequestSchema: GenMessage<UpdateSCMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 25);

/**
 * @generated from message gitpod.v1.UpdateSCMIntegrationResponse
 */
export type UpdateSCMIntegrationResponse = Message<"gitpod.v1.UpdateSCMIntegrationResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateSCMIntegrationResponse.
 * Use `create(UpdateSCMIntegrationResponseSchema)` to create a new message.
 */
export const UpdateSCMIntegrationResponseSchema: GenMessage<UpdateSCMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 26);

/**
 * @generated from message gitpod.v1.DeleteSCMIntegrationRequest
 */
export type DeleteSCMIntegrationRequest = Message<"gitpod.v1.DeleteSCMIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.DeleteSCMIntegrationRequest.
 * Use `create(DeleteSCMIntegrationRequestSchema)` to create a new message.
 */
export const DeleteSCMIntegrationRequestSchema: GenMessage<DeleteSCMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 27);

/**
 * @generated from message gitpod.v1.DeleteSCMIntegrationResponse
 */
export type DeleteSCMIntegrationResponse = Message<"gitpod.v1.DeleteSCMIntegrationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteSCMIntegrationResponse.
 * Use `create(DeleteSCMIntegrationResponseSchema)` to create a new message.
 */
export const DeleteSCMIntegrationResponseSchema: GenMessage<DeleteSCMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 28);

/**
 * @generated from message gitpod.v1.EnvironmentClass
 */
export type EnvironmentClass = Message<"gitpod.v1.EnvironmentClass"> & {
  /**
   * id is the unique identifier of the environment class
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * display_name is the human readable name of the environment class
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * description is a human readable description of the environment class
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * configuration describes the configuration of the environment class
   *
   * @generated from field: repeated gitpod.v1.FieldValue configuration = 4;
   */
  configuration: FieldValue[];

  /**
   * runner_id is the unique identifier of the runner the environment class belongs to
   *
   * @generated from field: string runner_id = 5;
   */
  runnerId: string;

  /**
   * enabled indicates whether the environment class can be used to create
   * new environments.
   *
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;
};

/**
 * Describes the message gitpod.v1.EnvironmentClass.
 * Use `create(EnvironmentClassSchema)` to create a new message.
 */
export const EnvironmentClassSchema: GenMessage<EnvironmentClass> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 29);

/**
 * @generated from message gitpod.v1.CreateEnvironmentClassRequest
 */
export type CreateEnvironmentClassRequest = Message<"gitpod.v1.CreateEnvironmentClassRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated gitpod.v1.FieldValue configuration = 4;
   */
  configuration: FieldValue[];
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentClassRequest.
 * Use `create(CreateEnvironmentClassRequestSchema)` to create a new message.
 */
export const CreateEnvironmentClassRequestSchema: GenMessage<CreateEnvironmentClassRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 30);

/**
 * @generated from message gitpod.v1.CreateEnvironmentClassResponse
 */
export type CreateEnvironmentClassResponse = Message<"gitpod.v1.CreateEnvironmentClassResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.CreateEnvironmentClassResponse.
 * Use `create(CreateEnvironmentClassResponseSchema)` to create a new message.
 */
export const CreateEnvironmentClassResponseSchema: GenMessage<CreateEnvironmentClassResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 31);

/**
 * @generated from message gitpod.v1.GetEnvironmentClassRequest
 */
export type GetEnvironmentClassRequest = Message<"gitpod.v1.GetEnvironmentClassRequest"> & {
  /**
   * @generated from field: string environment_class_id = 2;
   */
  environmentClassId: string;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentClassRequest.
 * Use `create(GetEnvironmentClassRequestSchema)` to create a new message.
 */
export const GetEnvironmentClassRequestSchema: GenMessage<GetEnvironmentClassRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 32);

/**
 * @generated from message gitpod.v1.GetEnvironmentClassResponse
 */
export type GetEnvironmentClassResponse = Message<"gitpod.v1.GetEnvironmentClassResponse"> & {
  /**
   * @generated from field: gitpod.v1.EnvironmentClass environment_class = 1;
   */
  environmentClass?: EnvironmentClass;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentClassResponse.
 * Use `create(GetEnvironmentClassResponseSchema)` to create a new message.
 */
export const GetEnvironmentClassResponseSchema: GenMessage<GetEnvironmentClassResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 33);

/**
 * @generated from message gitpod.v1.ListEnvironmentClassesRequest
 */
export type ListEnvironmentClassesRequest = Message<"gitpod.v1.ListEnvironmentClassesRequest"> & {
  /**
   * pagination contains the pagination options for listing environment classes
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListEnvironmentClassesRequest.Filter filter = 2;
   */
  filter?: ListEnvironmentClassesRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListEnvironmentClassesRequest.
 * Use `create(ListEnvironmentClassesRequestSchema)` to create a new message.
 */
export const ListEnvironmentClassesRequestSchema: GenMessage<ListEnvironmentClassesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 34);

/**
 * @generated from message gitpod.v1.ListEnvironmentClassesRequest.Filter
 */
export type ListEnvironmentClassesRequest_Filter = Message<"gitpod.v1.ListEnvironmentClassesRequest.Filter"> & {
  /**
   * runner_ids filters the response to only EnvironmentClasses of these Runner IDs
   *
   * @generated from field: repeated string runner_ids = 1;
   */
  runnerIds: string[];

  /**
   * enabled filters the response to only enabled or disabled environment classes.
   * If not set, all environment classes are returned.
   *
   * @generated from field: optional bool enabled = 2;
   */
  enabled?: boolean;

  /**
   * can_create_environments filters the response to only environment classes that can be used to create new environments
   * by the caller. Unlike enabled, which indicates general availability, this ensures the caller only sees environment classes
   * they are allowed to use.
   *
   * @generated from field: optional bool can_create_environments = 3;
   */
  canCreateEnvironments?: boolean;

  /**
   * runner_kind filters the response to only environment classes from runners of these kinds.
   *
   * @generated from field: repeated gitpod.v1.RunnerKind runner_kinds = 4;
   */
  runnerKinds: RunnerKind[];

  /**
   * runner_providers filters the response to only environment classes from runners of these providers.
   *
   * @generated from field: repeated gitpod.v1.RunnerProvider runner_providers = 5;
   */
  runnerProviders: RunnerProvider[];
};

/**
 * Describes the message gitpod.v1.ListEnvironmentClassesRequest.Filter.
 * Use `create(ListEnvironmentClassesRequest_FilterSchema)` to create a new message.
 */
export const ListEnvironmentClassesRequest_FilterSchema: GenMessage<ListEnvironmentClassesRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 34, 0);

/**
 * @generated from message gitpod.v1.ListEnvironmentClassesResponse
 */
export type ListEnvironmentClassesResponse = Message<"gitpod.v1.ListEnvironmentClassesResponse"> & {
  /**
   * pagination contains the pagination options for listing environment classes
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.EnvironmentClass environment_classes = 2;
   */
  environmentClasses: EnvironmentClass[];
};

/**
 * Describes the message gitpod.v1.ListEnvironmentClassesResponse.
 * Use `create(ListEnvironmentClassesResponseSchema)` to create a new message.
 */
export const ListEnvironmentClassesResponseSchema: GenMessage<ListEnvironmentClassesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 35);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentClassRequest
 */
export type UpdateEnvironmentClassRequest = Message<"gitpod.v1.UpdateEnvironmentClassRequest"> & {
  /**
   * @generated from field: string environment_class_id = 1;
   */
  environmentClassId: string;

  /**
   * @generated from field: optional string display_name = 2;
   */
  displayName?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional bool enabled = 4;
   */
  enabled?: boolean;
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentClassRequest.
 * Use `create(UpdateEnvironmentClassRequestSchema)` to create a new message.
 */
export const UpdateEnvironmentClassRequestSchema: GenMessage<UpdateEnvironmentClassRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 36);

/**
 * @generated from message gitpod.v1.UpdateEnvironmentClassResponse
 */
export type UpdateEnvironmentClassResponse = Message<"gitpod.v1.UpdateEnvironmentClassResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateEnvironmentClassResponse.
 * Use `create(UpdateEnvironmentClassResponseSchema)` to create a new message.
 */
export const UpdateEnvironmentClassResponseSchema: GenMessage<UpdateEnvironmentClassResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 37);

/**
 * @generated from message gitpod.v1.ValidateRunnerConfigurationRequest
 */
export type ValidateRunnerConfigurationRequest = Message<"gitpod.v1.ValidateRunnerConfigurationRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * @generated from oneof gitpod.v1.ValidateRunnerConfigurationRequest.config
   */
  config: {
    /**
     * @generated from field: gitpod.v1.EnvironmentClass environment_class = 2;
     */
    value: EnvironmentClass;
    case: "environmentClass";
  } | {
    /**
     * @generated from field: gitpod.v1.ValidateRunnerConfigurationRequest.ValidateSCMIntegration scm_integration = 3;
     */
    value: ValidateRunnerConfigurationRequest_ValidateSCMIntegration;
    case: "scmIntegration";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.ValidateRunnerConfigurationRequest.
 * Use `create(ValidateRunnerConfigurationRequestSchema)` to create a new message.
 */
export const ValidateRunnerConfigurationRequestSchema: GenMessage<ValidateRunnerConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 38);

/**
 * @generated from message gitpod.v1.ValidateRunnerConfigurationRequest.ValidateSCMIntegration
 */
export type ValidateRunnerConfigurationRequest_ValidateSCMIntegration = Message<"gitpod.v1.ValidateRunnerConfigurationRequest.ValidateSCMIntegration"> & {
  /**
   * id is the unique identifier of the SCM integration
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * scm_id references the scm_id in the runner's configuration schema that this integration is for
   *
   * @generated from field: string scm_id = 2;
   */
  scmId: string;

  /**
   * @generated from field: string host = 3;
   */
  host: string;

  /**
   * oauth_client_id is the OAuth app's client ID, if OAuth is configured.
   * If configured, oauth_client_secret must also be set.
   *
   * @generated from field: optional string oauth_client_id = 4;
   */
  oauthClientId?: string;

  /**
   * @generated from oneof gitpod.v1.ValidateRunnerConfigurationRequest.ValidateSCMIntegration.oauth_client_secret
   */
  oauthClientSecret: {
    /**
     * oauth_plaintext_client_secret is the OAuth app's client secret in clear text, if OAuth is configured.
     * This can be set to validate any new client secret before it is encrypted and stored. This value will
     * not be stored and get encrypted with the runner's public key before passing it to the runner.
     *
     * @generated from field: string oauth_plaintext_client_secret = 5;
     */
    value: string;
    case: "oauthPlaintextClientSecret";
  } | {
    /**
     * oauth_encrypted_client_secret is the OAuth app's client secret encrypted with the runner's public key,
     * if OAuth is configured.
     * This can be used to e.g. validate an already encrypted client secret of an existing SCM integration.
     *
     * @generated from field: bytes oauth_encrypted_client_secret = 6;
     */
    value: Uint8Array;
    case: "oauthEncryptedClientSecret";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: bool pat = 7;
   */
  pat: boolean;

  /**
   * issuer_url can be set to override the authentication provider URL, if it doesn't match the SCM host.
   *
   * @generated from field: optional string issuer_url = 8;
   */
  issuerUrl?: string;

  /**
   * virtual_directory is the virtual directory path for Azure DevOps Server (e.g., "/tfs").
   * This field is only used for Azure DevOps Server SCM integrations and should be empty for other SCM types.
   * Azure DevOps Server APIs work without collection when PAT scope is 'All accessible organizations'.
   *
   * @generated from field: optional string virtual_directory = 9;
   */
  virtualDirectory?: string;
};

/**
 * Describes the message gitpod.v1.ValidateRunnerConfigurationRequest.ValidateSCMIntegration.
 * Use `create(ValidateRunnerConfigurationRequest_ValidateSCMIntegrationSchema)` to create a new message.
 */
export const ValidateRunnerConfigurationRequest_ValidateSCMIntegrationSchema: GenMessage<ValidateRunnerConfigurationRequest_ValidateSCMIntegration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 38, 0);

/**
 * @generated from message gitpod.v1.FieldValidationError
 */
export type FieldValidationError = Message<"gitpod.v1.FieldValidationError"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message gitpod.v1.FieldValidationError.
 * Use `create(FieldValidationErrorSchema)` to create a new message.
 */
export const FieldValidationErrorSchema: GenMessage<FieldValidationError> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 39);

/**
 * @generated from message gitpod.v1.EnvironmentClassValidationResult
 */
export type EnvironmentClassValidationResult = Message<"gitpod.v1.EnvironmentClassValidationResult"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: optional string display_name_error = 2;
   */
  displayNameError?: string;

  /**
   * @generated from field: optional string description_error = 3;
   */
  descriptionError?: string;

  /**
   * @generated from field: repeated gitpod.v1.FieldValidationError configuration_errors = 4;
   */
  configurationErrors: FieldValidationError[];
};

/**
 * Describes the message gitpod.v1.EnvironmentClassValidationResult.
 * Use `create(EnvironmentClassValidationResultSchema)` to create a new message.
 */
export const EnvironmentClassValidationResultSchema: GenMessage<EnvironmentClassValidationResult> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 40);

/**
 * @generated from message gitpod.v1.SCMIntegrationValidationResult
 */
export type SCMIntegrationValidationResult = Message<"gitpod.v1.SCMIntegrationValidationResult"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: optional string scm_id_error = 2;
   */
  scmIdError?: string;

  /**
   * @generated from field: optional string host_error = 3;
   */
  hostError?: string;

  /**
   * @generated from field: optional string oauth_error = 4;
   */
  oauthError?: string;

  /**
   * @generated from field: optional string pat_error = 5;
   */
  patError?: string;
};

/**
 * Describes the message gitpod.v1.SCMIntegrationValidationResult.
 * Use `create(SCMIntegrationValidationResultSchema)` to create a new message.
 */
export const SCMIntegrationValidationResultSchema: GenMessage<SCMIntegrationValidationResult> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 41);

/**
 * @generated from message gitpod.v1.ValidateRunnerConfigurationResponse
 */
export type ValidateRunnerConfigurationResponse = Message<"gitpod.v1.ValidateRunnerConfigurationResponse"> & {
  /**
   * @generated from oneof gitpod.v1.ValidateRunnerConfigurationResponse.result
   */
  result: {
    /**
     * @generated from field: gitpod.v1.EnvironmentClassValidationResult environment_class = 1;
     */
    value: EnvironmentClassValidationResult;
    case: "environmentClass";
  } | {
    /**
     * @generated from field: gitpod.v1.SCMIntegrationValidationResult scm_integration = 2;
     */
    value: SCMIntegrationValidationResult;
    case: "scmIntegration";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.ValidateRunnerConfigurationResponse.
 * Use `create(ValidateRunnerConfigurationResponseSchema)` to create a new message.
 */
export const ValidateRunnerConfigurationResponseSchema: GenMessage<ValidateRunnerConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 42);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema
 */
export type RunnerConfigurationSchema = Message<"gitpod.v1.RunnerConfigurationSchema"> & {
  /**
   * The schema version
   *
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: repeated gitpod.v1.RunnerConfigurationSchema.Field runner_config = 2;
   */
  runnerConfig: RunnerConfigurationSchema_Field[];

  /**
   * @generated from field: repeated gitpod.v1.RunnerConfigurationSchema.Field environment_classes = 3;
   */
  environmentClasses: RunnerConfigurationSchema_Field[];

  /**
   * @generated from field: repeated gitpod.v1.RunnerConfigurationSchema.SCMConfigSchema scm = 4;
   */
  scm: RunnerConfigurationSchema_SCMConfigSchema[];
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.
 * Use `create(RunnerConfigurationSchemaSchema)` to create a new message.
 */
export const RunnerConfigurationSchemaSchema: GenMessage<RunnerConfigurationSchema> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.StringField
 */
export type RunnerConfigurationSchema_StringField = Message<"gitpod.v1.RunnerConfigurationSchema.StringField"> & {
  /**
   * @generated from field: string default = 1;
   */
  default: string;

  /**
   * @generated from field: string pattern = 2;
   */
  pattern: string;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.StringField.
 * Use `create(RunnerConfigurationSchema_StringFieldSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_StringFieldSchema: GenMessage<RunnerConfigurationSchema_StringField> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 0);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.BoolField
 */
export type RunnerConfigurationSchema_BoolField = Message<"gitpod.v1.RunnerConfigurationSchema.BoolField"> & {
  /**
   * @generated from field: bool default = 1;
   */
  default: boolean;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.BoolField.
 * Use `create(RunnerConfigurationSchema_BoolFieldSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_BoolFieldSchema: GenMessage<RunnerConfigurationSchema_BoolField> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 1);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.IntField
 */
export type RunnerConfigurationSchema_IntField = Message<"gitpod.v1.RunnerConfigurationSchema.IntField"> & {
  /**
   * @generated from field: int32 default = 1;
   */
  default: number;

  /**
   * @generated from field: int32 min = 2;
   */
  min: number;

  /**
   * @generated from field: int32 max = 3;
   */
  max: number;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.IntField.
 * Use `create(RunnerConfigurationSchema_IntFieldSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_IntFieldSchema: GenMessage<RunnerConfigurationSchema_IntField> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 2);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.EnumField
 */
export type RunnerConfigurationSchema_EnumField = Message<"gitpod.v1.RunnerConfigurationSchema.EnumField"> & {
  /**
   * deprecated, will be removed, use default_value instead
   *
   * @generated from field: string default = 1 [deprecated = true];
   * @deprecated
   */
  default: string;

  /**
   * deprecated, will be removed, use possible_values instead
   *
   * @generated from field: repeated string values = 2 [deprecated = true];
   * @deprecated
   */
  values: string[];

  /**
   * @generated from field: gitpod.v1.RunnerConfigurationSchema.EnumField.Value default_value = 3;
   */
  defaultValue?: RunnerConfigurationSchema_EnumField_Value;

  /**
   * @generated from field: repeated gitpod.v1.RunnerConfigurationSchema.EnumField.Value possible_values = 4;
   */
  possibleValues: RunnerConfigurationSchema_EnumField_Value[];
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.EnumField.
 * Use `create(RunnerConfigurationSchema_EnumFieldSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_EnumFieldSchema: GenMessage<RunnerConfigurationSchema_EnumField> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 3);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.EnumField.Value
 */
export type RunnerConfigurationSchema_EnumField_Value = Message<"gitpod.v1.RunnerConfigurationSchema.EnumField.Value"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string subtitle = 2;
   */
  subtitle: string;

  /**
   * @generated from field: string detail = 3;
   */
  detail: string;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.EnumField.Value.
 * Use `create(RunnerConfigurationSchema_EnumField_ValueSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_EnumField_ValueSchema: GenMessage<RunnerConfigurationSchema_EnumField_Value> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 3, 0);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.DisplayField
 */
export type RunnerConfigurationSchema_DisplayField = Message<"gitpod.v1.RunnerConfigurationSchema.DisplayField"> & {
  /**
   * @generated from field: string default = 1;
   */
  default: string;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.DisplayField.
 * Use `create(RunnerConfigurationSchema_DisplayFieldSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_DisplayFieldSchema: GenMessage<RunnerConfigurationSchema_DisplayField> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 4);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.Field
 */
export type RunnerConfigurationSchema_Field = Message<"gitpod.v1.RunnerConfigurationSchema.Field"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool required = 4;
   */
  required: boolean;

  /**
   * @generated from field: bool secret = 5;
   */
  secret: boolean;

  /**
   * @generated from oneof gitpod.v1.RunnerConfigurationSchema.Field.type
   */
  type: {
    /**
     * @generated from field: gitpod.v1.RunnerConfigurationSchema.StringField string = 6;
     */
    value: RunnerConfigurationSchema_StringField;
    case: "string";
  } | {
    /**
     * @generated from field: gitpod.v1.RunnerConfigurationSchema.BoolField bool = 7;
     */
    value: RunnerConfigurationSchema_BoolField;
    case: "bool";
  } | {
    /**
     * @generated from field: gitpod.v1.RunnerConfigurationSchema.IntField int = 8;
     */
    value: RunnerConfigurationSchema_IntField;
    case: "int";
  } | {
    /**
     * @generated from field: gitpod.v1.RunnerConfigurationSchema.EnumField enum = 9;
     */
    value: RunnerConfigurationSchema_EnumField;
    case: "enum";
  } | {
    /**
     * @generated from field: gitpod.v1.RunnerConfigurationSchema.DisplayField display = 10;
     */
    value: RunnerConfigurationSchema_DisplayField;
    case: "display";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.Field.
 * Use `create(RunnerConfigurationSchema_FieldSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_FieldSchema: GenMessage<RunnerConfigurationSchema_Field> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 5);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.OAuth
 */
export type RunnerConfigurationSchema_OAuth = Message<"gitpod.v1.RunnerConfigurationSchema.OAuth"> & {
  /**
   * callback_url is the URL the OAuth app will redirect to after the user has authenticated.
   *
   * @generated from field: string callback_url = 1;
   */
  callbackUrl: string;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.OAuth.
 * Use `create(RunnerConfigurationSchema_OAuthSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_OAuthSchema: GenMessage<RunnerConfigurationSchema_OAuth> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 6);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.PersonalAccessToken
 */
export type RunnerConfigurationSchema_PersonalAccessToken = Message<"gitpod.v1.RunnerConfigurationSchema.PersonalAccessToken"> & {
  /**
   * description is a human-readable description of the PAT.
   *
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * docs_link is a link to the documentation on how to create a PAT for this SCM system.
   *
   * @generated from field: string docs_link = 2;
   */
  docsLink: string;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.PersonalAccessToken.
 * Use `create(RunnerConfigurationSchema_PersonalAccessTokenSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_PersonalAccessTokenSchema: GenMessage<RunnerConfigurationSchema_PersonalAccessToken> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 7);

/**
 * @generated from message gitpod.v1.RunnerConfigurationSchema.SCMConfigSchema
 */
export type RunnerConfigurationSchema_SCMConfigSchema = Message<"gitpod.v1.RunnerConfigurationSchema.SCMConfigSchema"> & {
  /**
   * @generated from field: string scm_id = 1;
   */
  scmId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated string default_hosts = 3;
   */
  defaultHosts: string[];

  /**
   * @generated from field: gitpod.v1.RunnerConfigurationSchema.OAuth oauth = 4;
   */
  oauth?: RunnerConfigurationSchema_OAuth;

  /**
   * @generated from field: gitpod.v1.RunnerConfigurationSchema.PersonalAccessToken pat = 5;
   */
  pat?: RunnerConfigurationSchema_PersonalAccessToken;
};

/**
 * Describes the message gitpod.v1.RunnerConfigurationSchema.SCMConfigSchema.
 * Use `create(RunnerConfigurationSchema_SCMConfigSchemaSchema)` to create a new message.
 */
export const RunnerConfigurationSchema_SCMConfigSchemaSchema: GenMessage<RunnerConfigurationSchema_SCMConfigSchema> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 43, 8);

/**
 * LLMIntegrationRequestHeader represents a custom header to be passed to LLM requests.
 * The value field contains:
 * - Plain text values in update requests (will be encrypted server-side).
 * - Encrypted binary values on read requests (decrypt directly to get original value).
 *
 * @generated from message gitpod.v1.LLMIntegrationRequestHeader
 */
export type LLMIntegrationRequestHeader = Message<"gitpod.v1.LLMIntegrationRequestHeader"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: bytes value = 2;
   */
  value: Uint8Array;
};

/**
 * Describes the message gitpod.v1.LLMIntegrationRequestHeader.
 * Use `create(LLMIntegrationRequestHeaderSchema)` to create a new message.
 */
export const LLMIntegrationRequestHeaderSchema: GenMessage<LLMIntegrationRequestHeader> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 44);

/**
 * @generated from message gitpod.v1.LLMIntegration
 */
export type LLMIntegration = Message<"gitpod.v1.LLMIntegration"> & {
  /**
   *  id is the unique identifier of the LLM integration
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * models represents the supported LLM models for this integration
   *
   * @generated from field: repeated gitpod.v1.SupportedModel models = 3;
   */
  models: SupportedModel[];

  /**
   * @generated from field: string endpoint = 4;
   */
  endpoint: string;

  /**
   * encrypted_api_key is the LLM provider's API key encrypted with the runner's public key.
   *
   * @generated from field: bytes encrypted_api_key = 5;
   */
  encryptedApiKey: Uint8Array;

  /**
   * the maximum number of tokens to generate before stopping. 0 is a model default.
   *
   * @generated from field: uint64 max_tokens = 6;
   */
  maxTokens: bigint;

  /**
   * phase represents the current status/phase of the LLM integration
   *
   * @generated from field: gitpod.v1.LLMIntegrationPhase phase = 7;
   */
  phase: LLMIntegrationPhase;

  /**
   * phase_reason provides explanation for the current phase (e.g., "insufficient funds", "user disabled")
   *
   * @generated from field: string phase_reason = 8;
   */
  phaseReason: string;

  /**
   * request_headers contains optional headers for the LLM integration.
   *
   * @generated from field: repeated gitpod.v1.LLMIntegrationRequestHeader request_headers = 9;
   */
  requestHeaders: LLMIntegrationRequestHeader[];
};

/**
 * Describes the message gitpod.v1.LLMIntegration.
 * Use `create(LLMIntegrationSchema)` to create a new message.
 */
export const LLMIntegrationSchema: GenMessage<LLMIntegration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 45);

/**
 * @generated from message gitpod.v1.CreateLLMIntegrationRequest
 */
export type CreateLLMIntegrationRequest = Message<"gitpod.v1.CreateLLMIntegrationRequest"> & {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId: string;

  /**
   * models represents the LLM models this integration supports
   *
   * @generated from field: repeated gitpod.v1.SupportedModel models = 2;
   */
  models: SupportedModel[];

  /**
   * @generated from field: string endpoint = 3;
   */
  endpoint: string;

  /**
   * api_key is the LLM provider's API key.
   *
   * @generated from field: string api_key = 4;
   */
  apiKey: string;

  /**
   * max_tokens is the maximum number of tokens to generate before stopping.
   * If set to 0, the model's default will be used.
   *
   * @generated from field: uint64 max_tokens = 5;
   */
  maxTokens: bigint;
};

/**
 * Describes the message gitpod.v1.CreateLLMIntegrationRequest.
 * Use `create(CreateLLMIntegrationRequestSchema)` to create a new message.
 */
export const CreateLLMIntegrationRequestSchema: GenMessage<CreateLLMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 46);

/**
 * @generated from message gitpod.v1.CreateLLMIntegrationResponse
 */
export type CreateLLMIntegrationResponse = Message<"gitpod.v1.CreateLLMIntegrationResponse"> & {
  /**
   * id is a uniquely generated identifier for the LLM integration
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.CreateLLMIntegrationResponse.
 * Use `create(CreateLLMIntegrationResponseSchema)` to create a new message.
 */
export const CreateLLMIntegrationResponseSchema: GenMessage<CreateLLMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 47);

/**
 * @generated from message gitpod.v1.GetLLMIntegrationRequest
 */
export type GetLLMIntegrationRequest = Message<"gitpod.v1.GetLLMIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.GetLLMIntegrationRequest.
 * Use `create(GetLLMIntegrationRequestSchema)` to create a new message.
 */
export const GetLLMIntegrationRequestSchema: GenMessage<GetLLMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 48);

/**
 * @generated from message gitpod.v1.GetLLMIntegrationResponse
 */
export type GetLLMIntegrationResponse = Message<"gitpod.v1.GetLLMIntegrationResponse"> & {
  /**
   * @generated from field: gitpod.v1.LLMIntegration integration = 1;
   */
  integration?: LLMIntegration;
};

/**
 * Describes the message gitpod.v1.GetLLMIntegrationResponse.
 * Use `create(GetLLMIntegrationResponseSchema)` to create a new message.
 */
export const GetLLMIntegrationResponseSchema: GenMessage<GetLLMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 49);

/**
 * @generated from message gitpod.v1.ListLLMIntegrationsRequest
 */
export type ListLLMIntegrationsRequest = Message<"gitpod.v1.ListLLMIntegrationsRequest"> & {
  /**
   * pagination contains the pagination options for listing scm integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListLLMIntegrationsRequest.Filter filter = 2;
   */
  filter?: ListLLMIntegrationsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListLLMIntegrationsRequest.
 * Use `create(ListLLMIntegrationsRequestSchema)` to create a new message.
 */
export const ListLLMIntegrationsRequestSchema: GenMessage<ListLLMIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 50);

/**
 * @generated from message gitpod.v1.ListLLMIntegrationsRequest.Filter
 */
export type ListLLMIntegrationsRequest_Filter = Message<"gitpod.v1.ListLLMIntegrationsRequest.Filter"> & {
  /**
   * runner_ids filters the response to only LLM integrations of these Runner IDs
   *
   * @generated from field: repeated string runner_ids = 1;
   */
  runnerIds: string[];
};

/**
 * Describes the message gitpod.v1.ListLLMIntegrationsRequest.Filter.
 * Use `create(ListLLMIntegrationsRequest_FilterSchema)` to create a new message.
 */
export const ListLLMIntegrationsRequest_FilterSchema: GenMessage<ListLLMIntegrationsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 50, 0);

/**
 * @generated from message gitpod.v1.ListLLMIntegrationsResponse
 */
export type ListLLMIntegrationsResponse = Message<"gitpod.v1.ListLLMIntegrationsResponse"> & {
  /**
   * pagination contains the pagination options for listing llm integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.LLMIntegration integrations = 2;
   */
  integrations: LLMIntegration[];

  /**
   * llm_managed_by_ona indicates if LLM integrations are managed by Ona Intelligence.
   *
   * @generated from field: bool llm_managed_by_ona = 3;
   */
  llmManagedByOna: boolean;
};

/**
 * Describes the message gitpod.v1.ListLLMIntegrationsResponse.
 * Use `create(ListLLMIntegrationsResponseSchema)` to create a new message.
 */
export const ListLLMIntegrationsResponseSchema: GenMessage<ListLLMIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 51);

/**
 * @generated from message gitpod.v1.UpdateLLMIntegrationRequest
 */
export type UpdateLLMIntegrationRequest = Message<"gitpod.v1.UpdateLLMIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string endpoint = 2;
   */
  endpoint?: string;

  /**
   * models can be updated to change the supported LLM models
   * Set list of supported models to the given list.
   * Empty list means no updates to the models.
   *
   * @generated from field: repeated gitpod.v1.SupportedModel models = 3;
   */
  models: SupportedModel[];

  /**
   * api_key can be set to update the LLM provider's API key.
   * The cleartext secret will be encrypted with the runner's public key before being stored.
   *
   * @generated from field: optional string api_key = 4;
   */
  apiKey?: string;

  /**
   * max_tokens can be set to update the maximum number of tokens to generate before stopping.
   *
   * @generated from field: optional uint64 max_tokens = 5;
   */
  maxTokens?: bigint;

  /**
   * phase can be set to update the status/phase of the LLM integration
   *
   * @generated from field: optional gitpod.v1.LLMIntegrationPhase phase = 6;
   */
  phase?: LLMIntegrationPhase;

  /**
   * request_headers set optional headers for the LLM integration.
   *
   * @generated from field: repeated gitpod.v1.LLMIntegrationRequestHeader request_headers = 7;
   */
  requestHeaders: LLMIntegrationRequestHeader[];
};

/**
 * Describes the message gitpod.v1.UpdateLLMIntegrationRequest.
 * Use `create(UpdateLLMIntegrationRequestSchema)` to create a new message.
 */
export const UpdateLLMIntegrationRequestSchema: GenMessage<UpdateLLMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 52);

/**
 * @generated from message gitpod.v1.UpdateLLMIntegrationResponse
 */
export type UpdateLLMIntegrationResponse = Message<"gitpod.v1.UpdateLLMIntegrationResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateLLMIntegrationResponse.
 * Use `create(UpdateLLMIntegrationResponseSchema)` to create a new message.
 */
export const UpdateLLMIntegrationResponseSchema: GenMessage<UpdateLLMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 53);

/**
 * @generated from message gitpod.v1.DeleteLLMIntegrationRequest
 */
export type DeleteLLMIntegrationRequest = Message<"gitpod.v1.DeleteLLMIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * force skips dependency checks and deletes the integration even if it would
   * leave no enabled integration for a model in use
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message gitpod.v1.DeleteLLMIntegrationRequest.
 * Use `create(DeleteLLMIntegrationRequestSchema)` to create a new message.
 */
export const DeleteLLMIntegrationRequestSchema: GenMessage<DeleteLLMIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 54);

/**
 * @generated from message gitpod.v1.DeleteLLMIntegrationResponse
 */
export type DeleteLLMIntegrationResponse = Message<"gitpod.v1.DeleteLLMIntegrationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteLLMIntegrationResponse.
 * Use `create(DeleteLLMIntegrationResponseSchema)` to create a new message.
 */
export const DeleteLLMIntegrationResponseSchema: GenMessage<DeleteLLMIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_configuration, 55);

/**
 * @generated from enum gitpod.v1.HostAuthenticationTokenSource
 */
export enum HostAuthenticationTokenSource {
  /**
   * @generated from enum value: HOST_AUTHENTICATION_TOKEN_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: HOST_AUTHENTICATION_TOKEN_SOURCE_OAUTH = 1;
   */
  OAUTH = 1,

  /**
   * @generated from enum value: HOST_AUTHENTICATION_TOKEN_SOURCE_PAT = 2;
   */
  PAT = 2,
}

/**
 * Describes the enum gitpod.v1.HostAuthenticationTokenSource.
 */
export const HostAuthenticationTokenSourceSchema: GenEnum<HostAuthenticationTokenSource> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_configuration, 0);

/**
 * RunnerKind represents the kind of a runner
 *
 * @generated from enum gitpod.v1.RunnerKind
 */
export enum RunnerKind {
  /**
   * Invalid kind
   *
   * @generated from enum value: RUNNER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The runner is a local runner
   *
   * @generated from enum value: RUNNER_KIND_LOCAL = 1;
   */
  LOCAL = 1,

  /**
   * The runner is a remote runner
   *
   * @generated from enum value: RUNNER_KIND_REMOTE = 2;
   */
  REMOTE = 2,

  /**
   * The runner is a system-managed runner that holds shared configuration for local runners.
   * Every organization automatically has one of these runners, and it cannot be deleted nor
   * can new runners of this kind be created.
   * Organization admins can update this runner to change the shared configuration, including:
   * - SCM Integrations. All local runners will use these integrations.
   * - DesiredPhase. Can be set to STOPPED to disable all local runners.
   * This runner cannot be used to run environments.
   *
   * @generated from enum value: RUNNER_KIND_LOCAL_CONFIGURATION = 3;
   */
  LOCAL_CONFIGURATION = 3,
}

/**
 * Describes the enum gitpod.v1.RunnerKind.
 */
export const RunnerKindSchema: GenEnum<RunnerKind> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_configuration, 1);

/**
 * RunnerProvider identifies the specific implementation type of a runner.
 * Each provider maps to a specific kind of runner (local or remote), as
 * specified below for each provider.
 *
 * @generated from enum gitpod.v1.RunnerProvider
 */
export enum RunnerProvider {
  /**
   * @generated from enum value: RUNNER_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * AWS EC2 based runner that deploys as a CloudFormation stack
   * Kind: RUNNER_KIND_REMOTE
   *
   * @generated from enum value: RUNNER_PROVIDER_AWS_EC2 = 1;
   */
  AWS_EC2 = 1,

  /**
   * Runner that can be deployed on Linux hosts
   * Kind: RUNNER_KIND_REMOTE
   *
   * @generated from enum value: RUNNER_PROVIDER_LINUX_HOST = 2;
   */
  LINUX_HOST = 2,

  /**
   * macOS desktop runner for local development
   * Kind: RUNNER_KIND_LOCAL
   *
   * @generated from enum value: RUNNER_PROVIDER_DESKTOP_MAC = 3;
   */
  DESKTOP_MAC = 3,

  /**
   * Runner that is managed by the gitpod operated RunnerManager
   * Kind: RUNNER_KIND_REMOTE
   *
   * @generated from enum value: RUNNER_PROVIDER_MANAGED = 4;
   */
  MANAGED = 4,

  /**
   * Runner for GCP platform deployed using terraform
   * Kind: RUNNER_KIND_REMOTE
   *
   * @generated from enum value: RUNNER_PROVIDER_GCP = 5;
   */
  GCP = 5,

  /**
   * Dev runner for testing agent changes within a Gitpod environment
   * Kind: RUNNER_KIND_REMOTE
   *
   * @generated from enum value: RUNNER_PROVIDER_DEV_AGENT = 6;
   */
  DEV_AGENT = 6,
}

/**
 * Describes the enum gitpod.v1.RunnerProvider.
 */
export const RunnerProviderSchema: GenEnum<RunnerProvider> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_configuration, 2);

/**
 * @generated from service gitpod.v1.RunnerConfigurationService
 */
export const RunnerConfigurationService: GenService<{
  /**
   * Creates a new authentication token for accessing remote hosts.
   *
   * Use this method to:
   * - Set up SCM authentication
   * - Configure OAuth credentials
   * - Manage PAT tokens
   *
   * ### Examples
   *
   * - Create OAuth token:
   *
   *   Creates a new OAuth-based authentication token.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   host: "github.com"
   *   token: "gho_xxxxxxxxxxxx"
   *   source: HOST_AUTHENTICATION_TOKEN_SOURCE_OAUTH
   *   expiresAt: "2024-12-31T23:59:59Z"
   *   refreshToken: "ghr_xxxxxxxxxxxx"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateHostAuthenticationToken
   */
  createHostAuthenticationToken: {
    methodKind: "unary";
    input: typeof CreateHostAuthenticationTokenRequestSchema;
    output: typeof CreateHostAuthenticationTokenResponseSchema;
  },
  /**
   * Gets details about a specific host authentication token.
   *
   * Use this method to:
   * - View token information
   * - Check token expiration
   * - Verify token validity
   *
   * ### Examples
   *
   * - Get token details:
   *
   *   Retrieves information about a specific token.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.GetHostAuthenticationToken
   */
  getHostAuthenticationToken: {
    methodKind: "unary";
    input: typeof GetHostAuthenticationTokenRequestSchema;
    output: typeof GetHostAuthenticationTokenResponseSchema;
  },
  /**
   * Lists host authentication tokens with optional filtering.
   *
   * Use this method to:
   * - View all tokens
   * - Filter by runner or user
   * - Monitor token status
   *
   * ### Examples
   *
   * - List all tokens:
   *
   *   Shows all tokens with pagination.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - Filter by runner:
   *
   *   Lists tokens for a specific runner.
   *
   *   ```yaml
   *   filter:
   *     runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.ListHostAuthenticationTokens
   */
  listHostAuthenticationTokens: {
    methodKind: "unary";
    input: typeof ListHostAuthenticationTokensRequestSchema;
    output: typeof ListHostAuthenticationTokensResponseSchema;
  },
  /**
   * Updates an existing host authentication token.
   *
   * Use this method to:
   * - Refresh token values
   * - Update expiration
   * - Modify token settings
   *
   * ### Examples
   *
   * - Update token:
   *
   *   Updates token value and expiration.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   token: "gho_xxxxxxxxxxxx"
   *   expiresAt: "2024-12-31T23:59:59Z"
   *   refreshToken: "ghr_xxxxxxxxxxxx"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateHostAuthenticationToken
   */
  updateHostAuthenticationToken: {
    methodKind: "unary";
    input: typeof UpdateHostAuthenticationTokenRequestSchema;
    output: typeof UpdateHostAuthenticationTokenResponseSchema;
  },
  /**
   * Updates metadata for an existing host authentication token.
   *
   * Use this method to:
   * - Persist provider-derived identity metadata
   * - Attach external user mappings used by webhook handling
   *
   * ### Examples
   *
   * - Update external user ID:
   *
   *   Persists the provider user ID associated with the token.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   externalUserId: "12345678"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateHostAuthenticationTokenMetadata
   */
  updateHostAuthenticationTokenMetadata: {
    methodKind: "unary";
    input: typeof UpdateHostAuthenticationTokenMetadataRequestSchema;
    output: typeof UpdateHostAuthenticationTokenMetadataResponseSchema;
  },
  /**
   * Deletes a host authentication token.
   *
   * Use this method to:
   * - Remove unused tokens
   * - Revoke access
   * - Clean up expired tokens
   *
   * ### Examples
   *
   * - Delete token:
   *
   *   Permanently removes a token.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.DeleteHostAuthenticationToken
   */
  deleteHostAuthenticationToken: {
    methodKind: "unary";
    input: typeof DeleteHostAuthenticationTokenRequestSchema;
    output: typeof DeleteHostAuthenticationTokenResponseSchema;
  },
  /**
   * Gets the latest runner configuration schema.
   *
   * Use this method to:
   * - View available settings
   * - Check configuration options
   * - Validate configurations
   *
   * ### Examples
   *
   * - Get schema:
   *
   *   Retrieves configuration schema for a runner.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.GetRunnerConfigurationSchema
   */
  getRunnerConfigurationSchema: {
    methodKind: "unary";
    input: typeof GetRunnerConfigurationSchemaRequestSchema;
    output: typeof GetRunnerConfigurationSchemaResponseSchema;
  },
  /**
   * Creates a new SCM integration for a runner.
   *
   * Use this method to:
   * - Configure source control access
   * - Set up repository integrations
   * - Enable code synchronization
   *
   * ### Examples
   *
   * - Create GitHub integration:
   *
   *   Sets up GitHub SCM integration.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   scmId: "github"
   *   host: "github.com"
   *   oauthClientId: "client_id"
   *   oauthPlaintextClientSecret: "client_secret"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateSCMIntegration
   */
  createSCMIntegration: {
    methodKind: "unary";
    input: typeof CreateSCMIntegrationRequestSchema;
    output: typeof CreateSCMIntegrationResponseSchema;
  },
  /**
   * Gets details about a specific SCM integration.
   *
   * Use this method to:
   * - View integration settings
   * - Check integration status
   * - Verify configuration
   *
   * ### Examples
   *
   * - Get integration details:
   *
   *   Retrieves information about a specific integration.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.GetSCMIntegration
   */
  getSCMIntegration: {
    methodKind: "unary";
    input: typeof GetSCMIntegrationRequestSchema;
    output: typeof GetSCMIntegrationResponseSchema;
  },
  /**
   * Lists SCM integrations for a runner.
   *
   * Use this method to:
   * - View all integrations
   * - Monitor integration status
   * - Check available SCMs
   *
   * ### Examples
   *
   * - List integrations:
   *
   *   Shows all SCM integrations.
   *
   *   ```yaml
   *   filter:
   *     runnerIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.ListSCMIntegrations
   */
  listSCMIntegrations: {
    methodKind: "unary";
    input: typeof ListSCMIntegrationsRequestSchema;
    output: typeof ListSCMIntegrationsResponseSchema;
  },
  /**
   * Updates an existing SCM integration.
   *
   * Use this method to:
   * - Modify integration settings
   * - Update credentials
   * - Change configuration
   *
   * ### Examples
   *
   * - Update integration:
   *
   *   Updates OAuth credentials.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   oauthClientId: "new_client_id"
   *   oauthPlaintextClientSecret: "new_client_secret"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateSCMIntegration
   */
  updateSCMIntegration: {
    methodKind: "unary";
    input: typeof UpdateSCMIntegrationRequestSchema;
    output: typeof UpdateSCMIntegrationResponseSchema;
  },
  /**
   * Deletes an SCM integration.
   *
   * Use this method to:
   * - Remove unused integrations
   * - Clean up configurations
   * - Revoke SCM access
   *
   * ### Examples
   *
   * - Delete integration:
   *
   *   Removes an SCM integration.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.DeleteSCMIntegration
   */
  deleteSCMIntegration: {
    methodKind: "unary";
    input: typeof DeleteSCMIntegrationRequestSchema;
    output: typeof DeleteSCMIntegrationResponseSchema;
  },
  /**
   * Creates a new environment class for a runner.
   *
   * Use this method to:
   * - Define compute resources
   * - Configure environment settings
   * - Set up runtime options
   *
   * ### Examples
   *
   * - Create environment class:
   *
   *   Creates a new environment configuration.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   displayName: "Large Instance"
   *   description: "8 CPU, 16GB RAM"
   *   configuration:
   *     - key: "cpu"
   *       value: "8"
   *     - key: "memory"
   *       value: "16384"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateEnvironmentClass
   */
  createEnvironmentClass: {
    methodKind: "unary";
    input: typeof CreateEnvironmentClassRequestSchema;
    output: typeof CreateEnvironmentClassResponseSchema;
  },
  /**
   * Gets details about a specific environment class.
   *
   * Use this method to:
   * - View class configuration
   * - Check resource settings
   * - Verify availability
   *
   * ### Examples
   *
   * - Get class details:
   *
   *   Retrieves information about a specific class.
   *
   *   ```yaml
   *   environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.GetEnvironmentClass
   */
  getEnvironmentClass: {
    methodKind: "unary";
    input: typeof GetEnvironmentClassRequestSchema;
    output: typeof GetEnvironmentClassResponseSchema;
  },
  /**
   * Lists environment classes with optional filtering.
   *
   * Use this method to:
   * - View available classes
   * - Filter by capability
   * - Check enabled status
   *
   * ### Examples
   *
   * - List all classes:
   *
   *   Shows all environment classes.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - Filter enabled classes:
   *
   *   Lists only enabled environment classes.
   *
   *   ```yaml
   *   filter:
   *     enabled: true
   *   pagination:
   *     pageSize: 20
   *   ```
   * buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.ListEnvironmentClasses
   */
  listEnvironmentClasses: {
    methodKind: "unary";
    input: typeof ListEnvironmentClassesRequestSchema;
    output: typeof ListEnvironmentClassesResponseSchema;
  },
  /**
   * Updates an environment class.
   *
   * Use this method to:
   * - Modify class settings
   * - Update resource limits
   * - Change availability
   *
   * ### Examples
   *
   * - Update class:
   *
   *   Changes class configuration.
   *
   *   ```yaml
   *   environmentClassId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   displayName: "Updated Large Instance"
   *   description: "16 CPU, 32GB RAM"
   *   enabled: true
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateEnvironmentClass
   */
  updateEnvironmentClass: {
    methodKind: "unary";
    input: typeof UpdateEnvironmentClassRequestSchema;
    output: typeof UpdateEnvironmentClassResponseSchema;
  },
  /**
   * Validates a runner configuration.
   *
   * Use this method to:
   * - Check configuration validity
   * - Verify integration settings
   * - Validate environment classes
   *
   * ### Examples
   *
   * - Validate SCM integration:
   *
   *   Checks if an SCM integration is valid.
   *
   *   ```yaml
   *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   scmIntegration:
   *     id: "integration-id"
   *     scmId: "github"
   *     host: "github.com"
   *     oauthClientId: "client_id"
   *     oauthPlaintextClientSecret: "client_secret"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.ValidateRunnerConfiguration
   */
  validateRunnerConfiguration: {
    methodKind: "unary";
    input: typeof ValidateRunnerConfigurationRequestSchema;
    output: typeof ValidateRunnerConfigurationResponseSchema;
  },
  /**
   * Creates a new LLM integration for a runner.
   *
   * Use this method to:
   * - Configure LLM access
   * - Set up LLM integrations
   * - Enable LLM usage
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.CreateLLMIntegration
   */
  createLLMIntegration: {
    methodKind: "unary";
    input: typeof CreateLLMIntegrationRequestSchema;
    output: typeof CreateLLMIntegrationResponseSchema;
  },
  /**
   * Gets details about a specific LLM integration.
   *
   * Use this method to:
   * - View integration settings
   * - Check integration status
   * - Verify configuration
   *
   * ### Examples
   *
   * - Get integration details:
   *
   *   Retrieves information about a specific integration.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.GetLLMIntegration
   */
  getLLMIntegration: {
    methodKind: "unary";
    input: typeof GetLLMIntegrationRequestSchema;
    output: typeof GetLLMIntegrationResponseSchema;
  },
  /**
   * Lists LLM integrations for a runner.
   *
   * Use this method to:
   * - View all integrations
   * - Monitor integration status
   * - Check available LLMs
   *
   * ### Examples
   *
   * - List integrations:
   *
   *   Shows all LLM integrations.
   *
   *   ```yaml
   *   filter:
   *     runnerIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.ListLLMIntegrations
   */
  listLLMIntegrations: {
    methodKind: "unary";
    input: typeof ListLLMIntegrationsRequestSchema;
    output: typeof ListLLMIntegrationsResponseSchema;
  },
  /**
   * Updates an existing LLM integration.
   *
   * Use this method to:
   * - Modify integration settings
   * - Update credentials
   * - Change configuration
   *
   * ### Examples
   *
   * - Update integration:
   *
   *   Updates OAuth credentials.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   apiKey: "sk-..."
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.UpdateLLMIntegration
   */
  updateLLMIntegration: {
    methodKind: "unary";
    input: typeof UpdateLLMIntegrationRequestSchema;
    output: typeof UpdateLLMIntegrationResponseSchema;
  },
  /**
   * Deletes an LLM integration.
   *
   * Use this method to:
   * - Remove unused integrations
   * - Clean up configurations
   * - Revoke LLM access
   *
   * ### Examples
   *
   * - Delete integration:
   *
   *   Removes an LLM integration.
   *
   *   ```yaml
   *   id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.RunnerConfigurationService.DeleteLLMIntegration
   */
  deleteLLMIntegration: {
    methodKind: "unary";
    input: typeof DeleteLLMIntegrationRequestSchema;
    output: typeof DeleteLLMIntegrationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_runner_configuration, 0);

